export const FILTER_USERS_CHART_REQUEST = "FILTER_USERS_CHART_REQUEST";
export const FILTER_USERS_CHART_SUCCESS = "FILTER_USERS_CHART_SUCCESS";
export const FILTER_USERS_CHART_FAILURE = "FILTER_USERS_CHART_FAILURE";
